import { useEffect } from 'react';
import {
  activateListBackupQueue,
  deactivateListBackupQueue,
  notifyListBackupOnline,
} from '../lib/listBackupQueue';

/** Liga boot e retorno da rede ao motor persistido de S6.2 para a conta ativa. */
export function useListBackupQueue(userId: string | undefined): void {
  useEffect(() => {
    if (!userId) return;

    activateListBackupQueue(userId);
    const handleOnline = (): void => {
      // `online` não prova conectividade; apenas pede uma tentativa que ainda pode falhar.
      notifyListBackupOnline(userId);
    };
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('online', handleOnline);
      deactivateListBackupQueue(userId);
    };
  }, [userId]);
}
